import React from 'react';
import Icons from '../../../public/icons/FeaturesIcons';

const WhyChooseUs = ({
    title = "Why Choose Coin Circle Trust",
    description = "Experience the future of background verification with our advanced AI platform.",
    features = [
        {
            icon: "features-icon1",
            title: "Higher Accuracy",
            description: "AI cross-verifies data from multiple sources to ensure reliability."
        },
        {
            icon: "features-icon2",
            title: "Faster Hiring Decisions",
            description: "Reduce verification timelines and onboard candidates quicker."
        },
        {
            icon: "features-icon3",
            title: "Scalable & Cost-Efficient",
            description: "Designed to handle high volumes without increasing operational costs."
        },
        {
            icon: "features-icon4",
            title: "Compliance-First Approach",
            description: "Ensure adherence to data privacy and employment regulations."
        },
        {
            icon: "features-icon5",
            title: "Built for India & Global Hiring",
            description: "Optimized for complex data environments and multi-region hiring."
        }
    ]
}) => {

    return (
        <section className="bg-[#1C46AA] py-24 relative overflow-hidden">
            {/* Background decorative elements can be added here */}
            <div className="container-padding-x mx-auto px-4 relative z-10 max-w-6xl">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        {title}
                    </h2>
                    <p className="text-blue-100 text-lg max-w-3xl mx-auto">
                        {description}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {features.map((feature, index) => (
                        <div key={index} className="bg-[#2D5BBD] border border-[#4571D1] rounded-2xl p-8 hover:bg-[#3462C4] transition-colors group">
                            <div className="mb-6 w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center group-hover:bg-white/20 transition-colors text-white">
                                <Icons name={feature.icon} hoverColor="true" cardIndex={index} />
                                {/* Using hoverColor logic from FeaturesIcons if applicable, or just letting it render default */}
                            </div>
                            <h3 className="text-white font-bold text-xl mb-3">
                                {feature.title}
                            </h3>
                            <p className="text-blue-100 text-sm leading-relaxed">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
